var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './input.module.css';
import clsx from 'clsx';
import styles from './input.module.css';
export var Input = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'text' : _b, placeholder = _a.placeholder, isDisabled = _a.isDisabled, state = _a.state, autocomplete = _a.autocomplete, _c = _a.labelText, labelText = _c === void 0 ? '' : _c, onInputBlur = _a.onInputBlur, onInputChange = _a.onInputChange, onInputFocus = _a.onInputFocus, id = _a.id, _d = _a.isRequired, isRequired = _d === void 0 ? false : _d, pattern = _a.pattern, bindToInput = _a.bindToInput, props = __rest(_a, ["type", "placeholder", "isDisabled", "state", "autocomplete", "labelText", "onInputBlur", "onInputChange", "onInputFocus", "id", "isRequired", "pattern", "bindToInput"]);
    return (_jsx("div", __assign({ className: clsx(styles.input, isDisabled && styles.inputDisabled) }, props, { children: _jsxs("label", __assign({ className: styles.inputLabel }, { children: [_jsxs("span", __assign({ className: styles.inputLabelText }, { children: [labelText, ' ', isRequired && _jsx("span", __assign({ className: styles.asterisk }, { children: "*" }))] })), _jsx("input", __assign({ className: clsx(styles.inputInput, state ? styles["input__".concat(state)] : null), type: type, disabled: isDisabled, placeholder: placeholder, autoComplete: autocomplete, id: id, onBlur: onInputBlur, onChange: onInputChange, onFocus: onInputFocus, required: isRequired, pattern: pattern }, bindToInput))] })) })));
};
export default Input;
